<ion-content id="spContent">
  <div class="navigation">
    <ion-icon name="arrow-back-circle-sharp" *ngIf="getactiveStep()!==1"
      (click)="getBack()" class="protocol-goback">
    </ion-icon>

    <ion-icon name="close-circle-sharp" (click)="closeProtocol()"
      class="close-protocol">
    </ion-icon>
  </div>
  <ng-container [ngSwitch]="getactiveStep()">
    <!---------------------------------------STEP1----------------------------------->
    <ion-grid *ngSwitchCase="1" class="question">
      <ion-row>
        <ion-col>
          <div class="ion-text-center">
            <ion-icon name="camera-sharp"></ion-icon>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div class="ion-text-center smoking-step">
            {{'smoking-protocol.take-photo' |translate}}
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-button expand="block" color="success"
            (click)="addPhotoToGallery()" id="pbYes">
            {{'smoking-protocol.yes' |translate}}
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button expand="block" color="danger" (click)="setactiveStep(2)"
            id="pbNo">
            {{'smoking-protocol.no' |translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid *ngSwitchCase="2" class="question">
      <!---------------------------------------STEP2----------------------------------->
      <ion-row>
        <ion-col>
          <div class="ion-text-center">
            <ion-icon name="compass-sharp"></ion-icon>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div class="ion-text-center smoking-step">
            {{'smoking-protocol.location' |translate}}
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-button expand="block" color="success"
            (click)="setLocation('outdoor')" id="lbOutdoor">
            {{'smoking-protocol.outdoors' |translate}}
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button expand="block" color="warning"
            (click)="setLocation('indoor')" id="lbIndoor">
            {{'smoking-protocol.indoors' |translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid *ngSwitchCase="3" class="question">
      <!---------------------------------------STEP3----------------------------------->
      <ion-row>
        <ion-col>
          <div class="ion-text-center">
            <ion-icon name="cut-sharp"></ion-icon>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div class="ion-text-center smoking-step">
            {{'smoking-protocol.how-cutted' |translate}}
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-button expand="block" color="success" (click)="setCut('double')"
            id="cbDouble">
            {{'smoking-protocol.doppelklinge' |translate}}
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button expand="block" color="warning" (click)="setCut('v-cut')"
            id="cbV">
            {{'smoking-protocol.kerbschnitt' |translate}}
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button expand="block" color="primary" (click)="setCut('drill')"
            id="cbDrill">
            {{'smoking-protocol.gebohrt' |translate}}
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button expand="block" color="medium" (click)="setCut('scissors')"
            id="cbScissors">
            {{'smoking-protocol.schere' |translate}}
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button expand="block" color="tertiary" (click)="setCut('none')"
            id="cbPre">
            {{'smoking-protocol.vorgeschnitten' |translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid *ngSwitchCase="4">
      <!---------------------------------------STEP4----------------------------------->
      <ion-row>
        <ion-col>
          <div class="ion-text-center">
            <ion-icon name="eye-sharp"></ion-icon> &nbsp;
            <ion-icon name="md-toro"></ion-icon>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div class="ion-text-center smoking-step">
            {{'smoking-protocol.appearance' |translate}}
          </div>
        </ion-col>
      </ion-row>
      <form [formGroup]="wrapperForm" (ngSubmit)="submitWrapper()">
        <ion-row>
          <ion-col>
            <div class="ion-text-center smoking-step">

              <ion-list id="appearance-list">
                <ion-item lines="none">
                  <ion-label>{{'smoking-protocol.color' |translate}}</ion-label>
                  <ion-select multiple="false"
                    [value]="smokingProtocol.cigarWrapper.color"
                    id="wrapperColor"
                    interface="action-sheet"
                    [cancelText]="'smoking-protocol.cancel' |translate"
                    name="wrapper_color" formControlName="wrapper_color">
                    <ion-select-option value="dbl_claro"
                      class="dbl_claro">Double Claro</ion-select-option>
                    <ion-select-option value="claro"
                      class="claro">Claro</ion-select-option>
                    <ion-select-option value="col_claro"
                      class="col_claro">Colorado Claro</ion-select-option>
                    <ion-select-option value="colorado"
                      class="colorado">Colorado</ion-select-option>
                    <ion-select-option value="col_maduro"
                      class="col_maduro">Colorado Maduro</ion-select-option>
                    <ion-select-option value="maduro"
                      class="maduro">Maduro</ion-select-option>
                    <ion-select-option value="oscuro"
                      class="oscuro">Oscuro</ion-select-option>
                  </ion-select>
                </ion-item>
                <ion-item lines="none">
                  <ion-label>{{'smoking-protocol.wrapper-structure'
                    |translate}}</ion-label>
                  <ion-select multiple="false"
                    [value]="smokingProtocol.cigarWrapper.structure"
                    id="wrapperStructure"
                    [okText]="'smoking-protocol.choose' |translate"
                    [cancelText]="'smoking-protocol.cancel' |translate"
                    name="wrapper_structure"
                    formControlName="wrapper_structure">
                    <ion-select-option value="coarse">{{'smoking-protocol.grob'
                      |translate}}</ion-select-option>
                    <ion-select-option
                      value="medium">{{'smoking-protocol.medium-coarse'
                      |translate}}</ion-select-option>
                    <ion-select-option value="fine">{{'smoking-protocol.fine'
                      |translate}}</ion-select-option>
                  </ion-select>
                </ion-item>
                <ion-item lines="none">
                  <ion-label position="stacked">
                    {{'smoking-protocol.rating' |translate}}:
                    {{wrapperForm.value.wrapper_rating}}
                    <ng-container [ngSwitch]="wrapperForm.value.wrapper_rating">
                      (
                      <ng-container
                        *ngSwitchCase="0">{{'smoking-protocol.ungenügend'
                        |translate}}</ng-container>
                      <ng-container
                        *ngSwitchCase="2.5">{{'smoking-protocol.mangelhaft'
                        |translate}}</ng-container>
                      <ng-container
                        *ngSwitchCase="5">{{'smoking-protocol.ausreichend'
                        |translate}}</ng-container>
                      <ng-container
                        *ngSwitchCase="7.5">{{'smoking-protocol.befriedigend'
                        |translate}}</ng-container>
                      <ng-container *ngSwitchCase="10">{{'smoking-protocol.gut'
                        |translate}}</ng-container>
                      <ng-container
                        *ngSwitchCase="12.5">{{'smoking-protocol.sehrgut'
                        |translate}}</ng-container>
                      <ng-container
                        *ngSwitchCase="15">{{'smoking-protocol.hervorragend'
                        |translate}}</ng-container>
                      <ng-container
                        *ngSwitchDefault>{{'smoking-protocol.unknown'
                        |translate}}</ng-container>
                      )
                    </ng-container>
                  </ion-label>
                  <ion-range formControlName="wrapper_rating" min="0" max="15"
                    step="2.5" color="secondary" id="wrapperRating"
                    snaps="true" ticks="true" (ionChange)="calculateRating()">
                    <ion-label slot="end">15 ( {{'smoking-protocol.hervorragend'
                      |translate}} )</ion-label>
                  </ion-range>
                </ion-item>
                <ion-item lines="none">
                  <ion-textarea rows="3" cols="20" name="wrapper_adds"
                    type="text" maxlength="255" id="wrapperComments"
                    placeholder="{{'smoking-protocol.additional-comments' |translate}}"
                    inputmode="text"
                    [value]="smokingProtocol.cigarWrapper.comments"
                    formControlName="wrapper_comments">

                  </ion-textarea>
                </ion-item>
              </ion-list>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-button expand="block" color="success" type="submit"
              id="wrapperSubmit">
              {{'smoking-protocol.continue' |translate}}
            </ion-button>
          </ion-col>
        </ion-row>
      </form>
    </ion-grid>
    <ion-grid *ngSwitchCase="5">
      <!---------------------------------------STEP5----------------------------------->
      <ion-row>
        <ion-col class="spHeader">
          <div class="ion-text-center">
            <ion-icon name="wine-sharp"></ion-icon>
          </div>
          <div class="ion-text-center smoking-step">
            {{'smoking-protocol.beverage' |translate}}
          </div>
        </ion-col>
      </ion-row>
      <ng-container
        *ngFor="let drink of drinks | translationSort:'beverages', index as i ">
        <ion-row *ngIf="i%3===0" class="drinkRow">
          <ion-col size="4">
            <ion-chip outline="true" expand="block" [color]="drink.identifier"
              (click)="setBeverage(drink)" [id]="'drinkButton_'+i">
              {{"beverages."+drink.identifier | translate}} <span
                *ngIf="drink.matches" class="recom">*</span>
            </ion-chip>
          </ion-col>
          <ion-col size="4" *ngIf="drinks[i+1]">
            <ion-chip outline="true" expand="block"
              [color]="drinks[i+1].identifier"
              (click)="setBeverage(drinks[i+1])" [id]="'drinkButton_'+(i+1)">
              {{"beverages."+drinks[i+1].identifier | translate}} <span
                *ngIf="drinks[i+1].matches" class="recom">*</span>
            </ion-chip>
          </ion-col>
          <ion-col size="4" *ngIf="drinks[i+2]">
            <ion-chip outline="true" expand="block"
              [color]="drinks[i+2].identifier"
              (click)="setBeverage(drinks[i+2])" [id]="'drinkButton_'+(i+2)">
              {{"beverages."+drinks[i+2].identifier | translate}} <span
                *ngIf="drinks[i+2].matches" class="recom">*</span>
            </ion-chip>
          </ion-col>
          <!--
              <ion-col size="3" *ngIf="drinks[i+3]">
                <ion-chip outline="true" expand="block" [color]="drinks[i+3].identifier" (click)="setBeverage(drinks[i+3])"[id]="'drinkButton_'+(i+3)">
                {{"beverages."+drinks[i+3].identifier | translate}} <span *ngIf="drinks[i+3].matches" class="recom">*</span>
                </ion-chip>
              </ion-col>
              -->
        </ion-row>
      </ng-container>
      <ion-row>
        <ion-col size="12" class="annotation" *ngIf="showRecom===true">
          {{'smoking-protocol.beverage-recom' |translate}}
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid *ngSwitchCase="6" class="question">
      <!---------------------------------------STEP6----------------------------------->
      <ion-row>
        <ion-col>
          <div class="ion-text-center">
            <ion-icon name="md-toro" size="medium"></ion-icon>&nbsp;
            <ion-icon name="flame-sharp" size="large" class="flame"></ion-icon>

          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div class="ion-text-center smoking-step">
            {{'smoking-protocol.taste-analysis' |translate}}
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-button (click)="setactiveStep(7)" expand="block" color="success"
            id="ssButton">
            {{'smoking-protocol.light-enjoy' |translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid *ngSwitchCase="7">
      <!---------------------------------------STEP7 TIMER & AROMEN----------------------------------->
      <ion-row>
        <ion-col class="spHeader">
          <div class="ion-text-center">
            <ion-icon name="create-sharp"></ion-icon>
          </div>
          <div class="ion-text-center smoking-step">
            {{'smoking-protocol.aromas' |translate}}
          </div>
        </ion-col>
      </ion-row>
      <ng-container
        *ngFor="let aroma of aromas | translationSort:'flavors', index as i ">
        <ion-row *ngIf="i%4===0" class="aromasRow">
          <ion-col size="3">
            <ion-chip outline="true" expand="block" [color]="aroma.identifier"
              (click)="addAroma(aroma)" [disabled]="aromaAdded(aroma)"
              [id]="'aromaButton_'+i">
              {{"flavors."+aroma.identifier | translate}}
            </ion-chip>
          </ion-col>
          <ion-col size="3" *ngIf="aromas[i+1]">
            <ion-chip outline="true" expand="block"
              [color]="aromas[i+1].identifier" (click)="addAroma(aromas[i+1])"
              [id]="'aromaButton_'+(i+1)"
              [disabled]="aromaAdded(aromas[i+1])">
              {{"flavors."+aromas[i+1].identifier | translate }}
            </ion-chip>
          </ion-col>
          <ion-col size="3" *ngIf="aromas[i+2]">
            <ion-chip outline="true" expand="block"
              [color]="aromas[i+2].identifier" (click)="addAroma(aromas[i+2])"
              [disabled]="aromaAdded(aromas[i+2])" [id]="'aromaButton_'+(i+2)">
              {{"flavors."+aromas[i+2].identifier | translate}}
            </ion-chip>
          </ion-col>
          <ion-col size="3" *ngIf="aromas[i+3]">
            <ion-chip outline="true" expand="block"
              [color]="aromas[i+3].identifier" (click)="addAroma(aromas[i+3])"
              [disabled]="aromaAdded(aromas[i+3])" [id]="'aromaButton_'+(i+3)">
              {{"flavors."+aromas[i+3].identifier | translate}}
            </ion-chip>
          </ion-col>
        </ion-row>
      </ng-container>
      <ion-row id="actionRow">
        <ion-grid>
          <ion-row class="alertrow">
            <ion-col size="3">
              <ion-chip expand="block" (click)="spAlert('crooked')"
                id="crookedButton">
                <ion-icon name="alarm-sharp" size="small"></ion-icon>
                <ion-label class="alertlabel">
                  {{'smoking-protocol.crooked' |translate}}
                </ion-label>
              </ion-chip>
            </ion-col>
            <ion-col size="3">
              <ion-chip expand="block" (click)="spAlert('tunnel')"
                id="tunnelButton">
                <ion-icon name="alarm-sharp" size="small"></ion-icon>
                <ion-label class="alertlabel">
                  {{'smoking-protocol.tunnel' |translate}}
                </ion-label>
              </ion-chip>
            </ion-col>
            <ion-col size="3">
              <ion-chip expand="block" (click)="spAlert('ashfall')"
                id="wentoffButton">
                <ion-icon name="alarm-sharp" size="small"></ion-icon>
                <ion-label class="alertlabel">
                  {{'smoking-protocol.ashfall' |translate}}
                </ion-label>
              </ion-chip>
            </ion-col>
            <ion-col size="3">
              <ion-chip expand="block" (click)="spAlert('went_off')"
                id="wentoffButton">
                <ion-icon name="alarm-sharp" size="small"></ion-icon>
                <ion-label class="alertlabel">
                  {{'smoking-protocol.went-off' |translate}}
                </ion-label>
              </ion-chip>
            </ion-col>
          </ion-row>
      <ion-row>
        <ion-col class="smokingtime">
          <div class="ion-text-center">
            <p>
              {{'smoking-protocol.smoking-process-runs' |translate}}
              {{ss.timeString}}
            </p>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col *ngIf="smokingProtocol.status==='running'" size="6">
          <ion-button expand="block" (click)="stopSmoking()" color="warning">
            {{'smoking-protocol.pause-smoking' |translate}}
          </ion-button>
        </ion-col>
        <ion-col *ngIf="smokingProtocol.status==='paused'" size="6">
          <ion-button expand="block" (click)="continueSmoking()"
            color="warning">
            {{'smoking-protocol.continue-smoking' |translate}}
          </ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button expand="block" (click)="setactiveStep(8)" color="success"
            id="esButton">
            {{'smoking-protocol.stop-smoking' |translate}}
          </ion-button>
        </ion-col>
      </ion-row>
              </ion-grid>
      </ion-row>
    </ion-grid>

    <ion-grid *ngSwitchCase="8" id="summary">
      <form [formGroup]="finalRatingForm" (ngSubmit)="submitFinalRatingForm()">
        <!---------------------------------------STEP8 SUMMARY----------------------------------->
        <ion-row>
          <ion-col>
            <div class="ion-text-center">
              <ion-icon name="list-sharp"></ion-icon>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <div class="ion-text-center smoking-step">
              {{'smoking-protocol.summary' |translate}}
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-list class="summary">
              <ion-item
                *ngIf="smokingProtocol.photo!==false && smokingProtocol.photo!==true"
                class="image-container" lines="none">
                <ion-img [src]="getPhotoUrl(smokingProtocol.photo.path)">
                </ion-img>
              </ion-item>
              <ion-item lines="none">
                <ion-label position="stacked">
                  {{'smoking-protocol.cigar' |translate}}
                </ion-label>
                {{smokingProtocol.humEntry.cigar.name}}
              </ion-item>
              <ion-item lines="none">
                <ion-label position="stacked">{{'smoking-protocol.smoking-time'
                  |translate}}</ion-label>
                {{smokingProtocol.smokingTime}} {{'smoking-protocol.minutes'
                |translate}}
              </ion-item>
              <ion-item lines="none">
                <ion-label
                  position="stacked">{{'smoking-protocol.smoking-location'
                  |translate}}</ion-label>
                <ng-container [ngSwitch]="smokingProtocol.smokingLocation">
                  <ng-container
                    *ngSwitchCase="'outdoor'">{{'smoking-protocol.outdoors'
                    |translate}}</ng-container>
                  <ng-container *ngSwitchDefault>{{'smoking-protocol.indoors'
                    |translate}}</ng-container>
                </ng-container>
              </ion-item>
              <ion-item lines="none">
                <ion-label position="stacked">{{'smoking-protocol.cut'
                  |translate}}</ion-label>
                <ng-container [ngSwitch]="smokingProtocol.cut">
                  <ng-container
                    *ngSwitchCase="'double'">{{'smoking-protocol.doppelklinge'
                    |translate}}</ng-container>
                  <ng-container
                    *ngSwitchCase="'v-cut'">{{'smoking-protocol.kerbschnitt'
                    |translate}}</ng-container>
                  <ng-container
                    *ngSwitchCase="'drill'">{{'smoking-protocol.gebohrt'
                    |translate}}</ng-container>
                  <ng-container
                    *ngSwitchCase="'scissors'">{{'smoking-protocol.schere'
                    |translate}}</ng-container>
                  <ng-container
                    *ngSwitchDefault>{{'smoking-protocol.vorgeschnitten'
                    |translate}}</ng-container>
                </ng-container>
              </ion-item>
              <ion-item lines="none">
                <ion-label position="stacked">{{'smoking-protocol.wrapper-color'
                  |translate}}</ion-label>
                <ng-container [ngSwitch]="smokingProtocol.cigarWrapper.color">
                  <ng-container *ngSwitchCase="'dbl_claro'">Double
                    Claro</ng-container>
                  <ng-container *ngSwitchCase="'claro'">Claro</ng-container>
                  <ng-container *ngSwitchCase="'col_claro'">Colorado
                    Claro</ng-container>
                  <ng-container
                    *ngSwitchCase="'colorado'">Colorado</ng-container>
                  <ng-container *ngSwitchCase="'col_maduro'">Colorado
                    Maduro</ng-container>
                  <ng-container *ngSwitchCase="'maduro'">Maduro</ng-container>
                  <ng-container *ngSwitchCase="'oscuro'">Oscuro</ng-container>
                  <ng-container *ngSwitchDefault>Nicht ermittelt</ng-container>
                </ng-container>
              </ion-item>
              <ion-item lines="none">
                <ion-label
                  position="stacked">{{'smoking-protocol.wrapper-structure'
                  |translate}}</ion-label>
                <ng-container
                  [ngSwitch]="smokingProtocol.cigarWrapper.structure">
                  <ng-container
                    *ngSwitchCase="'coarse'">{{'smoking-protocol.coarse'
                    |translate}}</ng-container>
                  <ng-container *ngSwitchCase="'fine'">{{'smoking-protocol.fine'
                    |translate}}</ng-container>
                  <ng-container
                    *ngSwitchDefault>{{'smoking-protocol.medium-coarse'
                    |translate}}</ng-container>
                </ng-container>
              </ion-item>
              <ion-item *ngIf="smokingProtocol.cigarWrapper.comments"
                lines="none">
                {{'smoking-protocol.additional-comments' |translate}}:
                {{smokingProtocol.cigarWrapper.comments}}
              </ion-item>
              <ion-item lines="none">
                <ion-label position="stacked">
                  {{'smoking-protocol.rauch-pro-geld' |translate}} {{currency}}:
                </ion-label>
                {{ rauchProGeld() }}
              </ion-item>
              <ion-item lines="none">
                <ion-label
                  position="stacked">{{'smoking-protocol.registered-aromas'
                  |translate}}</ion-label>
                <ion-grid class="aromaGrid" size="12">
                  <ion-row>
                    <ion-col size="6">
                      <ion-list *ngIf="smokingProtocol.taste.length!==0"
                        class="aroma">
                        <ion-item lines="none" color="secondary" class="spacer">
                          {{'smoking-protocol.first-third' |translate}}
                        </ion-item>
                        <ng-container
                          *ngFor="let aroma of smokingProtocol.taste; let i=index">
                          <ion-item [color]="aroma.identifier" lines="none"
                            *ngIf="aroma.minute>=0 && aroma.minute < (smokingProtocol.smokingTime/3)"
                            [class]="'intense_'+aroma.intensity">
                            <ion-label (click)="removeAroma(i)" class="rmAroma">
                              <ion-icon name="close-circle-outline"
                                size="small"></ion-icon>
                            </ion-label>

                            <ion-label>
                              {{"flavors."+aroma.identifier | translate}}
                              <br>
                              <ng-container [ngSwitch]="aroma.intensity">
                                <span *ngSwitchCase="1" class="aromaStrength">
                                  {{'smoking-protocol.mild' |translate}}
                                </span>
                                <span *ngSwitchCase="2" class="aromaStrength">
                                  {{'smoking-protocol.medium' |translate}}
                                </span>
                                <span *ngSwitchCase="3" class="aromaStrength">
                                  {{'smoking-protocol.full' |translate}}
                                </span>

                              </ng-container>
                            </ion-label>
                          </ion-item>
                        </ng-container>
                        <ion-item lines="none" color="secondary" class="spacer">
                          {{'smoking-protocol.second-third' |translate}}
                        </ion-item>
                        <ng-container
                          *ngFor="let aroma of smokingProtocol.taste; let i=index">
                          <ion-item [color]="aroma.identifier" lines="none"
                            *ngIf="aroma.minute >= (smokingProtocol.smokingTime/3) && aroma.minute < (smokingProtocol.smokingTime/3)*2"
                            [class]="'intense_'+aroma.intensity">
                            <ion-label (click)="removeAroma(i)" class="rmAroma">
                              <ion-icon name="close-circle-outline"
                                size="small"></ion-icon>
                            </ion-label>
                            <ion-label>
                              {{"flavors."+aroma.identifier | translate}}
                              <br>
                              <ng-container [ngSwitch]="aroma.intensity">
                                <span *ngSwitchCase="1" class="aromaStrength">
                                  {{'smoking-protocol.mild' |translate}}
                                </span>
                                <span *ngSwitchCase="2" class="aromaStrength">
                                  {{'smoking-protocol.medium' |translate}}
                                </span>
                                <span *ngSwitchCase="3" class="aromaStrength">
                                  {{'smoking-protocol.full' |translate}}
                                </span>

                              </ng-container>
                            </ion-label>
                          </ion-item>
                        </ng-container>
                        <ion-item lines="none" color="secondary" class="spacer">
                          {{'smoking-protocol.last-third' |translate}}
                        </ion-item>
                        <ng-container
                          *ngFor="let aroma of smokingProtocol.taste; let i=index">
                          <ion-item [color]="aroma.identifier" lines="none"
                            [class]="'intense_'+aroma.intensity"
                            *ngIf="aroma.minute >= (smokingProtocol.smokingTime/3)*2 && aroma.minute <= smokingProtocol.smokingTime">
                            <ion-label (click)="removeAroma(i)" class="rmAroma">
                              <ion-icon name="close-circle-outline"
                                size="small"></ion-icon>
                            </ion-label>
                            <ion-label>
                              {{"flavors."+aroma.identifier | translate}}
                              <br>
                              <ng-container [ngSwitch]="aroma.intensity">
                                <span *ngSwitchCase="1" class="aromaStrength">
                                  {{'smoking-protocol.mild' |translate}}
                                </span>
                                <span *ngSwitchCase="2" class="aromaStrength">
                                  {{'smoking-protocol.medium' |translate}}
                                </span>
                                <span *ngSwitchCase="3" class="aromaStrength">
                                  {{'smoking-protocol.full' |translate}}
                                </span>

                              </ng-container>
                            </ion-label>
                          </ion-item>
                        </ng-container>
                      </ion-list>

                      <ng-container *ngIf="smokingProtocol.taste.length===0">
                        {{'smoking-protocol.none' |translate}}
                      </ng-container>
                    </ion-col>
                    <ion-col size="6">
                      <ion-list *ngIf="smokingProtocol.taste.length!==0"
                        id="aromaWeightingList">
                        <ion-item lines="none" class="spacer">
                          <!-- <ion-label>{{'smoking-protocol.aroma-weighting' |translate}}</ion-label>-->
                        </ion-item>
                        <ng-container
                          *ngFor="let aroma of smokingProtocol.taste; let i=index">
                          <ion-item
                            *ngIf="aroma.minute>=0 && aroma.minute < (smokingProtocol.smokingTime/3)"
                            lines="none" #aroma[i][aroma.identifier]
                            class="ranger">
                            <ion-range snaps ticks step="1" min="1" max="3"
                              (ionChange)="weightAroma(aroma,$event)"
                              [value]="aroma.intensity" color="secondary"
                              [id]="'aromaWeight_'+i">
                            </ion-range>
                          </ion-item>
                        </ng-container>
                        <ion-item lines="none" class="spacer">
                          <!--spacer-->
                        </ion-item>
                        <ng-container
                          *ngFor="let aroma of smokingProtocol.taste; let i=index">
                          <ion-item
                            *ngIf="aroma.minute >= (smokingProtocol.smokingTime/3) && aroma.minute < (smokingProtocol.smokingTime/3)*2"
                            lines="none" class="ranger"
                            #aroma[i][aroma.identifier]>
                            <ion-range snaps ticks step="1" min="1" max="3"
                              (ionChange)="weightAroma(aroma,$event)"
                              [value]="aroma.intensity" color="secondary"
                              [id]="'aromaWeight_'+i">
                            </ion-range>
                          </ion-item>
                        </ng-container>
                        <ion-item lines="none" class="spacer">
                          <!--spacer-->
                        </ion-item>
                        <ng-container
                          *ngFor="let aroma of smokingProtocol.taste; let i=index">
                          <ion-item
                            *ngIf="aroma.minute >= (smokingProtocol.smokingTime/3)*2 && aroma.minute <= smokingProtocol.smokingTime"
                            lines="none" #aroma[i][aroma.identifier]
                            class="ranger">
                            <ion-range snaps ticks step="1" min="1" max="3"
                              (ionChange)="weightAroma(aroma,$event)"
                              [value]="aroma.intensity" color="secondary"
                              [id]="'aromaWeight_'+i">
                            </ion-range>
                          </ion-item>
                        </ng-container>
                      </ion-list>
                    </ion-col>
                  </ion-row>
                </ion-grid>

              </ion-item>
              <ng-container *ngIf="smokingProtocol.alerts.length!==0">
                <ion-item lines="none">
                  <ion-label
                    position="stacked">{{'smoking-protocol.alerts-happened'
                    |translate}}</ion-label>
                  <ion-list class="alerts">
                    <ng-container *ngFor="let alert of smokingProtocol.alerts">
                      <ng-container [ngSwitch]="alert.type">
                        <ion-item lines="none" *ngSwitchCase="'crooked'">
                          {{'smoking-protocol.crooked-at' |translate}}
                          {{alert.time}}
                        </ion-item>
                        <ion-item lines="none" *ngSwitchCase="'tunnel'">
                          {{'smoking-protocol.tunnel-at' |translate}}
                          {{alert.time}}
                        </ion-item>
                        <ion-item lines="none" *ngSwitchCase="'went_off'">
                          {{'smoking-protocol.went-off-at' |translate}}
                          {{alert.time}}
                        </ion-item>
                        <ion-item lines="none" *ngSwitchCase="'ashfall'">
                          {{'smoking-protocol.ashfall-at' |translate}}
                          {{alert.time}}
                        </ion-item>
                        <ion-item lines="none" *ngSwitchDefault>
                          {{'smoking-protocol.undefined-problem' |translate}}
                        </ion-item>
                      </ng-container>
                    </ng-container>
                  </ion-list>
                </ion-item>
              </ng-container>
              <ng-container *ngIf="smokingProtocol.beverage.id!==0">
                <ion-item lines="none">
                  <ion-label position="stacked">
                    {{'smoking-protocol.beverage' |translate}}
                  </ion-label>
                  <ion-list class="beverages">
                    <ion-item [color]="smokingProtocol.beverage.identifier"
                      lines="none">
                      {{"beverages."+smokingProtocol.beverage.identifier |
                      translate}}
                    </ion-item>
                  </ion-list>
                </ion-item>
                <ion-item lines="none" id="drink-fits">
                  <ion-label position="stacked">
                    {{'smoking-protocol.drink-fit-question' |translate}}
                  </ion-label>
                  <ion-radio-group formControlName="beverage_fits"
                    id="beverageFitsSelect">
                    <ion-item lines="none">
                      <ion-radio value="2">
                      </ion-radio>
                      <ion-label class="thin"> {{'smoking-protocol.yes-fitted'
                        |translate}}</ion-label>
                    </ion-item>
                    <ion-item lines="none">
                      <ion-radio value="0"></ion-radio>
                      <ion-label class="thin">
                        {{'smoking-protocol.neutral-fitted'
                        |translate}}</ion-label>
                    </ion-item>
                    <ion-item lines="none">
                      <ion-radio value="1"></ion-radio>
                      <ion-label class="thin"> {{'smoking-protocol.no-fitted'
                        |translate}}</ion-label>
                    </ion-item>
                  </ion-radio-group>
                </ion-item>
              </ng-container>
              <ion-item lines="none">
                <ion-label position="stacked">
                  {{'smoking-protocol.evaluation' |translate}}:
                  {{finalRatingForm.value.cigar_strength}}
                  <ng-container
                    [ngSwitch]="finalRatingForm.value.cigar_strength">
                    (
                    <ng-container *ngSwitchCase="1">{{'smoking-protocol.mild'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="2">{{'smoking-protocol.mild-medium'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchCase="3">{{'smoking-protocol.medium'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="4">{{'smoking-protocol.medium-full'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchCase="5">{{'smoking-protocol.full'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchDefault>{{'smoking-protocol.unknown'
                      |translate}}</ng-container>
                    )
                  </ng-container>
                </ion-label>
                <ion-range formControlName="cigar_strength" min="1" max="5"
                  step="1" color="secondary"
                  snaps="true" ticks="true" name="cigar_strength"
                  id="cigarStrengthSlider">
                  <ion-label slot="end" class="thin">5 (
                    {{'smoking-protocol.full' |translate}} )</ion-label>
                </ion-range>
                <br>
              </ion-item>
              <ion-item lines="none">
                <ion-label position="stacked">
                  {{'smoking-protocol.final-review' |translate}}
                </ion-label>
                <ion-label position="stacked">
                  {{'smoking-protocol.draw-behavior' |translate}}:
                  {{finalRatingForm.value.cigar_draw}}
                  <ng-container [ngSwitch]="finalRatingForm.value.cigar_draw">
                    (
                    <ng-container *ngSwitchCase="0">{{'smoking-protocol.bad'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="1">{{'smoking-protocol.rather-bad'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="2">{{'smoking-protocol.not-bad-at-all'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchCase="3">{{'smoking-protocol.ok'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchCase="4">{{'smoking-protocol.good'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchCase="5">{{'smoking-protocol.optimal'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchDefault>{{'smoking-protocol.unknown'
                      |translate}}</ng-container>
                    )
                  </ng-container>
                </ion-label>
                <ion-range formControlName="cigar_draw" min="0" max="5" step="1"
                  color="secondary" id="drawSlider"
                  snaps="true" ticks="true" name="cigar_draw"
                  (ionChange)="calculateRating()">
                  <ion-label slot="end" class="thin">5 (
                    {{'smoking-protocol.optimal' |translate}} )</ion-label>
                </ion-range>
              </ion-item>
              <ion-item lines="none">
                <ion-label position="stacked">
                  {{'smoking-protocol.burnup' |translate}}:
                  {{finalRatingForm.value.cigar_burn}}
                  <ng-container [ngSwitch]="finalRatingForm.value.cigar_burn">
                    (
                    <ng-container *ngSwitchCase="0">{{'smoking-protocol.bad'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="1">{{'smoking-protocol.rather-bad'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="2">{{'smoking-protocol.not-bad-at-all'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchCase="3">{{'smoking-protocol.ok'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchCase="4">{{'smoking-protocol.good'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchCase="5">{{'smoking-protocol.optimal'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchDefault>{{'smoking-protocol.unknown'
                      |translate}}</ng-container>

                    )
                  </ng-container>
                </ion-label>
                <ion-range formControlName="cigar_burn" min="0" max="5" step="1"
                  color="secondary" id="burnSlider"
                  snaps="true" ticks="true" name="cigar_burn"
                  (ionChange)="calculateRating()">
                  <ion-label slot="end" class="thin">5 (
                    {{'smoking-protocol.optimal' |translate}} )</ion-label>
                </ion-range>
              </ion-item>
              <ion-item lines="none">
                <ion-label position="stacked">
                  {{'smoking-protocol.ashes' |translate}}:
                  {{finalRatingForm.value.cigar_ashes}}
                  <ng-container [ngSwitch]="finalRatingForm.value.cigar_ashes">
                    (
                    <ng-container *ngSwitchCase="0">{{'smoking-protocol.bad'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="1">{{'smoking-protocol.rather-bad'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="2">{{'smoking-protocol.not-bad-at-all'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchCase="3">{{'smoking-protocol.ok'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchCase="4">{{'smoking-protocol.good'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchCase="5">{{'smoking-protocol.optimal'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchDefault>{{'smoking-protocol.unknown'
                      |translate}}</ng-container>

                    )
                  </ng-container>
                </ion-label>
                <ion-range formControlName="cigar_ashes" min="0" max="5"
                  step="1" color="secondary" id="ashSlider"
                  snaps="true" ticks="true" name="cigar_ashes"
                  (ionChange)="calculateRating()">
                  <ion-label slot="end" class="thin">5 (
                    {{'smoking-protocol.optimal' |translate}} )</ion-label>
                </ion-range>
              </ion-item>
              <ion-item lines="none">
                <ion-label position="stacked">
                  {{'smoking-protocol.taste' |translate}}:
                  {{finalRatingForm.value.cigar_taste}}
                  <ng-container [ngSwitch]="finalRatingForm.value.cigar_taste">
                    (
                    <ng-container
                      *ngSwitchCase="0">{{'smoking-protocol.unbearable'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="7">{{'smoking-protocol.nearly-unbearable'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="14">{{'smoking-protocol.near-knuckle'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="21">{{'smoking-protocol.borderline'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="28">{{'smoking-protocol.still-bearable'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="35">{{'smoking-protocol.bearable'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="42">{{'smoking-protocol.not-bad'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="49">{{'smoking-protocol.rather-good'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchCase="56">{{'smoking-protocol.good'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="63">{{'smoking-protocol.very-good'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="70">{{'smoking-protocol.excellent'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchDefault>{{'smoking-protocol.unknown'
                      |translate}}</ng-container>
                    )
                  </ng-container>
                </ion-label>
                <ion-range formControlName="cigar_taste" min="0" max="70"
                  step="7" color="secondary" id="tasteSlider"
                  snaps="true" ticks="true" name="cigar_taste"
                  (ionChange)="calculateRating()">
                  <ion-label slot="end" class="thin">70 (
                    {{'smoking-protocol.excellent' |translate}} )</ion-label>
                </ion-range>
              </ion-item>
              <ion-item lines="none">
                <ion-label position="stacked">{{'smoking-protocol.appearance'
                  |translate}}</ion-label>
                <p>
                  <ng-container
                    [ngSwitch]="smokingProtocol.cigarWrapper.rating">
                    <ng-container
                      *ngSwitchCase="0">{{'smoking-protocol.ungenügend'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="2.5">{{'smoking-protocol.mangelhaft'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="5">{{'smoking-protocol.ausreichend'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="7.5">{{'smoking-protocol.befriedigend'
                      |translate}}</ng-container>
                    <ng-container *ngSwitchCase="10">{{'smoking-protocol.gut'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="12.5">{{'smoking-protocol.sehrgut'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchCase="15">{{'smoking-protocol.hervorragend'
                      |translate}}</ng-container>
                    <ng-container
                      *ngSwitchDefault>{{'smoking-protocol.not-rated'
                      |translate}}</ng-container>
                  </ng-container>
                  ( {{smokingProtocol.cigarWrapper.rating}}
                  {{'smoking-protocol.points' |translate}} )
                </p>
              </ion-item>
              <ion-item lines="none">
                <ion-label position="stacked">
                  {{'smoking-protocol.overall-rating' |translate}}:
                </ion-label>
                {{smokingProtocol.ratingComplete}} {{'smoking-protocol.points'
                |translate}}
                (
                <ng-container *ngIf="smokingProtocol.ratingComplete <= 100 &&
              smokingProtocol.ratingComplete >= 85">
                  {{'smoking-protocol.sehrgut' |translate}}
                </ng-container>
                <ng-container *ngIf="smokingProtocol.ratingComplete<85 &&
              smokingProtocol.ratingComplete>=70">
                  {{'smoking-protocol.good' |translate}}
                </ng-container>
                <ng-container *ngIf="smokingProtocol.ratingComplete<70 &&
              smokingProtocol.ratingComplete>=55">
                  {{'smoking-protocol.befriedigend' |translate}}
                </ng-container>
                <ng-container *ngIf="smokingProtocol.ratingComplete<55 &&
              smokingProtocol.ratingComplete>=40">
                  {{'smoking-protocol.ausreichend' |translate}}
                </ng-container>
                <ng-container *ngIf="smokingProtocol.ratingComplete<40 &&
              smokingProtocol.ratingComplete>=20">
                  {{'smoking-protocol.mangelhaft' |translate}}
                </ng-container>
                <ng-container *ngIf="smokingProtocol.ratingComplete<20 &&
              smokingProtocol.ratingComplete>=0">
                  {{'smoking-protocol.ungenügend' |translate}}
                </ng-container>
                )
              </ion-item>
              <ion-item lines="none">
                <ion-textarea rows="3" cols="20" name="conclusion" type="text"
                  maxlength="4096" id="conclusionText"
                  placeholder="{{'smoking-protocol.final-comment' |translate}}"
                  inputmode="text"
                  [value]="smokingProtocol.conclusion"
                  formControlName="conclusion">

                </ion-textarea>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-button expand="block" color="success" type="submit"
              id="submitProt">
              {{'smoking-protocol.save-protocol' |translate}}
            </ion-button>
          </ion-col>
        </ion-row>
      </form>
    </ion-grid>

  </ng-container>
</ion-content>
